/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SafetyDto } from '../../models/safety-dto';

export interface CreateSafety$Params {
      body: SafetyDto
}

export function createSafety(http: HttpClient, rootUrl: string, params: CreateSafety$Params, context?: HttpContext): Observable<StrictHttpResponse<SafetyDto>> {
  const rb = new RequestBuilder(rootUrl, createSafety.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SafetyDto>;
    })
  );
}

createSafety.PATH = '/safeties';
